import { useEffect } from 'react';
import queryString from 'query-string';
import { useAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { updateUrl } from '@/utils';

export function useFilterSyncWithParms() {
  const [selectedTemplateFilters, setSelectedTemplateFilters] = useAtom(
    state.selectedTemplateFiltersState
  );
  const [selectedDeckIds, setSelectedDeckIds] = useAtom(state.selectedFilteredDeckIds);
  const [selectedWorkpackIds, SetselectedWorkpackIds] = useAtom(state.selectedFilteredWorkpackIds);
  const [selectedPaintRegionIds, setSelectedPaintRegionId] = useAtom(
    state.selectedFilteredPaintRegionIds
  );

  useEffect(() => {
    const query = window.location.search;
    const parsed = queryString.parse(query, { arrayFormat: 'comma' });

    if (parsed.templateFilters) {
      const filters = JSON.parse(parsed.templateFilters.toString());
      const mappedFilteres = filters.map(({ id, o }: { id: string; o: string[] }) => ({
        id,
        value: [...o],
      }));
      setSelectedTemplateFilters(mappedFilteres);
    }

    if (parsed.paintRegionFilter) {
      const filter = JSON.parse(parsed.paintRegionFilter.toString());
      setSelectedPaintRegionId(filter.value ?? []);
    }

    if (parsed.deckFilters) {
      const filter = JSON.parse(parsed.deckFilters.toString());
      setSelectedDeckIds(filter.value ?? []);
    }
    if (parsed.workPackFilter) {
      const filter = JSON.parse(parsed.workPackFilter.toString());
      SetselectedWorkpackIds(filter.value ?? []);
    }
  }, [
    setSelectedPaintRegionId,
    setSelectedTemplateFilters,
    setSelectedDeckIds,
    SetselectedWorkpackIds,
  ]);

  useEffect(() => {
    const filters = [
      {
        key: 'templateFilters',
        has: () => selectedTemplateFilters.length > 0,
        value: () =>
          JSON.stringify(selectedTemplateFilters.map((f) => ({ id: f.id, o: [...f.value] }))),
      },
      {
        key: 'paintRegionFilter',
        has: () => selectedPaintRegionIds.length > 0,
        value: () => JSON.stringify({ id: 'paintRegionIds', value: selectedPaintRegionIds }),
      },
      {
        key: 'deckFilters',
        has: () => selectedDeckIds.length > 0,
        value: () => JSON.stringify({ id: 'selectedDeckIds', value: selectedDeckIds }),
      },
      {
        key: 'workPackFilter',
        has: () => selectedWorkpackIds.length > 0,
        value: () => JSON.stringify({ id: 'workpackIds', value: selectedWorkpackIds }),
      },
    ];

    for (const { key, has, value } of filters) {
      updateUrl(key, has() ? value() : undefined);
    }
  }, [selectedTemplateFilters, selectedPaintRegionIds, selectedDeckIds, selectedWorkpackIds]);
}
